/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrossCompanyMoveFolderContentsCto } from '../../models/cross-company-move-folder-contents-cto';
import { CrossCompanyMoveFolderContentsResultCto } from '../../models/cross-company-move-folder-contents-result-cto';

export interface MoveFolderContents$Json$Params {
      body?: CrossCompanyMoveFolderContentsCto
}

export function moveFolderContents$Json(http: HttpClient, rootUrl: string, params?: MoveFolderContents$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>> {
  const rb = new RequestBuilder(rootUrl, moveFolderContents$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CrossCompanyMoveFolderContentsResultCto>;
    })
  );
}

moveFolderContents$Json.PATH = '/crosscompanyfolder/movefoldercontents';
